<template>
  <modal
    :show.sync="show"
    modal-classes="modal-dialog-centered"
    body-classes="pt-1"
    @close="closeModal"
  >
    <template slot="header">
      <h4 class="subtitle mb-0" id="BlackoutDate">Blackout Date {{ show }}</h4>
    </template>

    <div class="col-12 pt-4">
      <div class="row">
        <div class="col-lg-9 col-md-9 col-sm-8 col-8">
          <base-input
            class
            v-model="$v.blackout.name.$model"
            label="Name"
            placeholder="Name"
            id="Blackout"
            name="Blackout"
            tabindex="6"
            :error="
              !$v.blackout.name.minLength || $v.blackout.name.$error
                ? `Enter a Name`
                : ''
            "
          />
        </div>

        <div class="col-lg-3 col-md-3 col-sm-4 col-4">
          <label class="title-label-np">Active</label>
          <base-switch v-model="blackout.status"></base-switch>
        </div>

        <div class="col-lg-5 col-sm-6 col-6">
          <base-input label="From Date">
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{
                altFormat: formatDateFlatPicker,
                altInput: true,
                minDate: 'today',
                dateFormat: 'Y-m-d',
                allowInput: true
              }"
              class="input-custom"
              v-model="blackout.from"
              id="from_date"
              name="from_date"
              placeholder="From date"
            ></flat-picker>
          </base-input>
        </div>
        <div class="col-lg-7">
          <label for class="title-label-np">Ends</label>

          <div class="row">
            <div class="col-lg-12 col-sm-12 col-12">
              <base-radio
                class="mr-4 ml-3"
                name="never"
                value="never"
                v-model="custom_end"
                >Never</base-radio
              >
            </div>

            <div class="col-lg-4 col-sm-4 col-4">
              <base-radio
                class="mr-4 ml-3"
                name="on"
                value="on"
                v-model="custom_end"
                >On</base-radio
              >
            </div>
            <div class="col-lg-7 col-sm-6 col-8">
              <base-input class="mb-0" style="margin-bottom: 0 !important">
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{
                    altFormat: formatDateFlatPicker,
                    minDate: 'today',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    allowInput: true
                  }"
                  class="input-custom mb-0"
                  v-model="blackout.end"
                  id="EditendOn"
                  name="EditendOn"
                  :disabled="!(custom_end === 'on')"
                  placeholder="End On"
                ></flat-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-12 col-sm-12 col-12">
              <label class="title-label-np">Description</label>
              <textarea
                class="input-custom form-control"
                id="event_description"
                name="event_description"
                v-model="blackout.description"
                cols="30"
                rows="2"
                v-bind:class="{ 'is-invalid': $v.blackout.description.$error }"
              ></textarea>
              <small
                style="display: block"
                class="invalid-feedback"
                v-if="$v.blackout.description.$error"
                >Minimum 8 Characters</small
              >
            </div>
          </div>
        </div>

        <div class="col-12 alinmov2 mt-4">
          <base-button type="primary" class="min-button" @click="saveBlackout">
            <i class="flaticon-floppy-disk"></i>Save Blackout Date
          </base-button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import lodash from "lodash";
import moment from "moment-timezone";
moment.tz.setDefault("Europe/London");
import { DatePicker, TimeSelect } from "element-ui";

import { required, minLength } from "vuelidate/lib/validators";
import selectcustom from "@/components/Select";
selectcustom.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "NewBlackOut",
  props: {
    value: {
      type: Boolean
    }
  },
  data() {
    return {
      blackout: {
        name: "",
        status: true,
        from: moment().format("YYYY-MM-DD"),
        end: moment()
          .add(7, "days")
          .format("YYYY-MM-DD"),
        description: ""
      },
      show: false,
      custom_end: "on"
    };
  },
  created() {},
  watch: {
    value: {
      handler: function(current, old) {
        this.show = current;
      },
      deep: true
    },
    custom_end: function(newVal, oldVal) {}
  },
  methods: {
    closeModal: function(params) {
      this.clearBlackoutModel();
      this.$emit("onCloseNewBlackout", true);
    },
    saveBlackout() {
      this.$v.blackout.$touch();
      if (!this.$v.blackout.$invalid) {
        this.createBlackout(lodash.cloneDeep(this.blackout));
      } else {
      }
    },
    createBlackout(blackout) {
      try {
        this.$emit("onNewBlackout", blackout);
        this.clearBlackoutModel();
      } catch (error) {
        this.$emit("onNewBlackout", null);
      }
    },
    clearBlackoutModel() {
      this.$v.blackout.$reset();
      this.blackout.name = "";
      this.blackout.status = true;
      this.blackout.from = moment().format("YYYY-MM-DD");
      this.blackout.end = moment().format("YYYY-MM-DD");
      this.blackout.description = "";
    },
    ...mapMutations(["setLoad"])
  },
  computed: {
    ...mapGetters(["sesion"]),
    formatDateFlatPicker: function() {
      return "d-M-Y";
    },
    formatTimeFlatPicker: function() {
      return {
        altFormat: "G:i K",
        dateFormat: "G:i K",
        time_24hr: false
      };
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    flatPicker,
    selectcustom
  },
  validations: {
    blackout: {
      name: {
        required,
        minLength: minLength(5)
      },
      status: {
        required
      },
      description: {
        required,
        minLength: minLength(8)
      }
    }
  }
};
</script>
